<template>
  <div>

    <!-- 저장하기 -->
    <div class="btn-group-justify-end">
      <div class="button is-primary" @click="saveData">저장하기</div>
    </div>

    <div class="columns is-multiline">
      <div class="column is-full">
        <div class="box">
          <admin-box-item title="파트너별 상품 기획전 등록 / 수정">
            <div class="columns is-multiline">
              <div class="column is-5">
                <admin-form-item label="기획전 제목*">
                  <input class="input"
                        :value="showcaseItem.title"
                        @input="e => showcaseItem.title = e.target.value"
                        placeholder="기획전 제목을 입력하세요."
                        type="text">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="기획전 대표 이미지">
                  <input-img :url.sync="showcaseItem.img"></input-img>
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="기획전 노출 여부">
                  <div>
                    <lp-radio :val.sync="showcaseItem.display_type"
                              value_name="value"
                              label_name="label"
                              :data="displayArr"></lp-radio>
                    <div v-show="showcaseItem.display_type===1"
                        style="display:flex; padding-top: 8px;" >
                      <admin-date-picker
                        :data="showcaseItem.start_date"
                        @setDate="selDateMin"></admin-date-picker>
                      <div class="lp-dating">&#126;</div>
                      <admin-date-picker
                            :data="showcaseItem.end_date"
                            @setDate="selDateMax"></admin-date-picker>
                    </div>
                  </div>
                </admin-form-item>
              </div>
              <!--<div class="column is-full">
                <admin-form-item label="파트너 기획전 종류">
                  <lp-radio :val.sync="showcaseItem.type"
                        :data="exhibitionArr" ></lp-radio>
                </admin-form-item>
              </div>-->
              <div class="column is-full">
                <admin-form-item label="기획전 설명">
                  <textarea placeholder="기획전 설명을 작성하세요."
                            class="textarea"
                            v-model="showcaseItem.desc"></textarea>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>

        <div class="column is-full">
          <div class="box">
            <admin-box-item title="기획전 파트너 정보">
              <div class="columns is-multiline">
                <div class="column is-full">
                  <admin-form-item label="파트너 조회">
                    <button class="button is-primary"
                            @click="openSelectPartner">파트너 검색</button>
                  </admin-form-item>
                </div>
              </div>
            </admin-box-item>
          </div>
          <div class="box">
            <admin-box-item title="파트너/상품 정보">
              <div style="overflow-x: auto">
                <button class="button" style="margin-bottom:32px"
                  :class="{'is-primary': !dragState}" @click="dragState=!dragState">{{ dragState ? '순서 변경 완료' : '파트너 순서 변경'}}</button>
                <table class="table">
                  <draggable element="tbody" v-model="showcaseItem.partner_list" handle=".item">
                    <div v-for="(pi,idx) in showcaseItem.partner_list" :key="'partner-item'+idx"
                      class="lp-row many-field-tr" style="margin-bottom:24px">
                      <div class="flex-between" style="margin-bottom:16px">
                        <div class="flex-align">
                          <div class="item" ref="dragIndi">
                            <div class="unselect" style="padding: 4px 4px 0 0">
                              <i style="color:#ccc" class="material-icons">drag_indicator</i>
                            </div>
                          </div>
                          <div style="margin-right:40px"><span style="font-weight:700;margin-right:12px">파트너 {{ idx+1 }}:</span>{{ pi.name }}</div>
                        </div>
                        <div class="flex-align">
                          <div><button class="button is-danger" @click="deletePartnerItem(idx, pi)">삭제</button></div>
                          <div style="margin-left:20px"><button class="button" @click="openSelectProduct(pi)">상품 검색</button></div>
                        </div>
                      </div>

                      <div v-if="!dragState">
                        <table class="table" style="table-layout: fixed;background-color:#F1F1F1">
                          <thead>
                            <tr class="tr-whole-border">
                              <th style="width:50px"></th>
                              <th style="width:40px;">순서</th>
                              <th style="width: 40px;">id</th>
                              <th style="width: 120px;">상품등록일</th>
                              <th style="width: 70px;">노출여부</th>
                              <th style="width: 80px;">카테고리</th>
                              <th style="width: 64px;">파트너명</th>
                              <th style="width: 84px;">이미지</th>
                              <th style="width: 80px;">상품명</th>
                              <th style="width: 100px;">판매가/기준</th>
                              <th style="width: 40px;">조회</th>
                              <th style="width: 40px;">리뷰</th>
                              <th style="width: 100px;" v-if="visibleField('order_count')">주문신청</th>
                              <th style="width: 100px;" v-if="visibleField('purchase_count')">구매완료</th>
                              <th style="width: 100px;" v-if="visibleField('call_count')">전화연결</th>
                              <th style="width: 150px;">기획전 상품 삭제</th>
                            </tr>
                          </thead>
                          <template v-if="pi.product_list && pi.product_list.length>0">
                            <draggable element="tbody" v-model="pi.product_list" handle=".item">
                              <tr v-for="(pro,idx) in pi.product_list" :key="'product-item'+idx" class="lp-row many-field-tr">
                                <td></td>
                                <td class="item">
                                  <div class="unselect" style="padding: 4px 4px 0 0">
                                    <i style="color:#ccc" class="material-icons">drag_indicator</i>
                                  </div>
                                </td>
                                <td>{{ pro.id }}</td>
                                <td>{{ pro.created_time }}</td>
                                <td><span>{{ pro.enable_prod ? '노출함': '노출안함' }}</span></td>
                                <td>{{ pro.category }}</td>
                                <td style="width:60px">{{ pro.partner.name }}</td>
                                <td style="padding: 6px 12px;">
                                  <div style="text-align: center;display: inline-block"
                                      :style="thumbImgField(pro.first_img)" v-if="pro.first_img"></div>
                                  <!-- <div :style="'background-image: url('+image(pro.img)+'); width: 60px; height: 60px; background-size: cover; background-posiproon: center;'"></div> -->
                                </td>
                                <td>{{ pro.name }}</td>
                                <td>{{ pro.price.price | currency }} / {{ pro.price.unit }}</td>
                                <td>{{ pro.visit }}</td>
                                <td>{{ pro.review_count }}</td>
                                <td v-if="visibleField('order_count')">{{ pro.order_count }}</td>
                                <td v-if="visibleField('purchase_count')">{{ pro.purchase_count }}</td>
                                <td v-if="visibleField('call_count')">{{ pro.call_count }}</td>
                                <td><button class="button is-danger half" @click="deleteProductItem(idx, pi)">삭제</button></td>
                              </tr>
                            </draggable>
                          </template>
                        </table>
                      </div>

                    </div>
                  </draggable>
                </table>
              </div>
            </admin-box-item>
          </div>
        </div>
    </div>

    <modal name="partnerListModal" :adaptive="true" :width="900" height="auto" class="modal-style">
      <partner-list @tableItems="partnerItems" page="exhibition" :selectedItems="showcaseItem.partners" style="zoom: 0.85"></partner-list>
    </modal>

    <modal name="productListModal" :adaptive="true" :width="900" height="auto" class="modal-style">
      <product-list @productItems="productItems" page="exhibition"
        :selectedItems="showcaseItem.products[selectedPartner ? selectedPartner.id : 0]" style="zoom: 0.85" :partnerProd="selectedPartner"></product-list>
    </modal>
  </div>
</template>

<script>
import LpInputText from "../../module/common/LpInputText";
import LpRadio from "../../module/common/LpRadio";
import InputImg from "../../module/common/InputImg";
import LpAddress from "../../module/common/LpAddress";
import LpAdmDropInput from "../../module/common/LpAdmDropInput";
import LpCheckBool from "../../module/common/LpCheckBool";
import LpSortDropDown from "../../module/common/LpSortDropDown";
import { SweetModal } from 'sweet-modal-vue';
import CreateMixin from '@/mixins/CreateMixin';
import PartnerList from "../partner/PartnerList";
import ProductList from '../product/ProductList';
import draggable from 'vuedraggable'

export default {
  layout: "ExhibitionPartnerProductReg",
  components: {
    PartnerList,
    ProductList,
    LpInputText,
    LpRadio,
    InputImg,
    LpAddress,
    LpAdmDropInput,
    SweetModal,
    LpCheckBool,
    LpSortDropDown,
    draggable,
  },
  mixins: [
    CreateMixin
  ],
  created() {
    /*this.nowTime=moment().format('YY-MM-DD');

    let start_year = parseInt(moment().format('YYYY'));
    let start_month = parseInt(moment().format('M'));
    let start_date = parseInt(moment().format('D'));

    let end_year = parseInt(moment().add(5, 'days').format('YYYY'));
    let end_month = parseInt(moment().add(5, 'days').format('M'));
    let end_date = parseInt(moment().add(5, 'days').format('D'));

    // this.showcaseItem.start_date = moment().format('YY-MM-DD');
    // this.showcaseItem.end_date = moment().add(5 ,'days').format('YY-MM-DD');
    this.showcaseItem.start_date = new Date (start_year, start_month-1, start_date);
    this.showcaseItem.end_date = new Date (end_year, end_month-1, end_date);
*/
    this.getData();
  },
  mounted() {

  },
  data() {
    return {
      // 아이디만 들어있는 배열
      nowTime: '',
      // 파트너 기획전 정보
      showcaseItem: {
        id: 0,
        // 기획전 등록일
        reg_date: '',
        // 노출여부 (현재 노출할것인지)
        display_type: 0,
        // 기간별 노출여부 (노출여부display와 상관없이 모든 값 존재)
        // state가 true일 경우(상시노출일 경우)에만 end값이 '99-12-31 23:59:59'
        start_date:'',
        end_date:'',
        // 선택된 파트너 id 리스트. 파트너 검색시 선택된 파트너 용도로 사용
        partners:[],
        // 파트너 리스트. product_list를 안고 있음
        partner_list: [],
        // 파트너별 상품 id 리스트. key는 파트너 id. value는 파트너의 상품 id 목록.
        products: {},
        type: '파트너별 상품 기획전',
        img: '',
        title: '',
        description: '',
        count: 20
      },
      // showcaseItem: {
      //   id: 82,
      //   // 기획전 등록일
      //   reg_date: '17-12-30 10:24:20',
      //   // 노출여부 (현재 노출할것인지)
      //   display: true,
      //   // 기간별 노출여부 (노출여부display와 상관없이 모든 값 존재)
      //   // state가 true일 경우(상시노출일 경우)에만 end값이 '99-12-31 23:59:59'
      //   displayAll: {
      //     state: true,   // true: 상시노출, false: 기간노출
      //     start: '18-01-02 12:00:00',
      //     end: '99-12-31 23:59:59'
      //   },
      //   type: '상품기획전',
      //   img: 'http://pds.joins.com/news/component/newsis/201308/06/NISI20130806_0008507689_web.jpg',
      //   title: '여름맞이 창고 대개방',
      //   description: '여름맞이 창고 대개방 최대 70%까지 할인 행사',
      //   count: 20
      // },
      // 노출여부
      displayArr: [
        { label: '노출', value: 0 },
        { label: '기간노출', value: 1 },
        { label: '노출안함', value: 2 }
      ],
      // 기간별 노출여부
      displayTermArr: [
        { label: '전체', value: '전체' },
        { label: '상시노출', value: '상시노출' },
        { label: '기간노출', value: '기간노출' }
      ],
      exhibitionArr: [
        { label: '상품기획전', value: '상품기획전'},
        { label: '테스트기획전1', value: '테스트기획전1'},
        { label: '테스트기획전2', value: '테스트기획전2'}
      ],
      // 상품정보
      partnerTable: [
        /*{
          hit: 0,
          name: "스몰장례 빈소형 상품",
          img:
            "https://dispatch.cdnser.be/wp-content/uploads/2017/10/20171018195354_1.jpg",
          // img: '3bd008d01e934c1485cd539199298854.png',
          region: "광주 동구",
          buy: 0,
          favorite: 0,
          display: "O",
          price: "10000 / kg",
          tag: ["스몰장례"],
          qna: 0,
          review: 0,
          date: "18-02-07 10:01",
          partner: "파트너",
          cat: "장례 > 장례업체",
          order: 0,
          id: 17      // 상품 id
        }*/
      ],
      selectedPartner: undefined,
      dragState: false
    }
  },
  watch: {
    /*modalResponse(n){
      if(n==='close'){
        this.showcaseItem.partners = n.partnerIdArr;
        this.partnerTable = n.partnerTable;
      }
    }*/
    'showcaseItem.partner_list'() {
      this.rearrangeIndex();
    }
  },
  methods: {
    openSelectProduct(item){
      this.selectedPartner = item;
      this.$modal.show('productListModal');
    },
    visibleField(key) {
      let is_key = false;
      if(this.showcaseItem.partner_list.length > 0) {
        for(let i=0; i<this.showcaseItem.partner_list.length; i++) {
          if(this.showcaseItem.partner_list[i][key]) is_key = true;
          break;
        }
      }
      return is_key;
    },
    // 상품 검색을 통해 선택한 파트너에 상품 목록 추가
    productItems(res){
      console.log('productItems',res)
      // 파트너의 id에 상품 id 리스트 추가
      this.showcaseItem.products[this.selectedPartner.id] = res.id_list;
      // 파트너 리스트에 상품 목록 추가
      this.showcaseItem.partner_list.filter(item => item.id === this.selectedPartner.id)[0].product_list = res.productItems;
      this.$modal.hide('productListModal');
      this.selectedPartner = undefined;
    },
    // 파트너 검색을 통해 파트너 추가
    partnerItems(res){
      // 기존 파트너 리스트에서 선택한 목록에 없는것 제거
      for(let j=0; j<this.showcaseItem.partners.length; j++) {
        if(res.id_list.includes(this.showcaseItem.partners[j])===false) {
          this.showcaseItem.partners.splice(j,1);
          this.showcaseItem.partner_list.splice(j,1);
        }
      }
      // 파트너 리스트와 id 리스트에 선택한 파트너 추가
      for(let i=0; i<res.id_list.length; i++){
        if(this.showcaseItem.partners.includes(res.id_list[i])===false){
          this.showcaseItem.partners.push(res.id_list[i]);
          this.showcaseItem.partner_list.push(res.tableItems[i]);
        }
      }
      this.$modal.hide('partnerListModal');
    },
    // 기획전 등록 파트너 검색
    openSelectPartner(idx){
      this.$modal.show('partnerListModal');
    },
    // 파트너 리스트에서 선택한 파트너 아이템 제거
    deletePartnerItem(idx, part){
      removeIndex(this.showcaseItem.partner_list, idx);
      removeIndex(this.showcaseItem.partners, idx);
      delete this.showcaseItem.products[part.id];
      console.log('deletePartner',idx)
    },
    // 파트너의 상품 리스트에서 선택한 상품 아이템 제거
    deleteProductItem(idx, part){
      removeIndex(this.showcaseItem.products[part.id], idx);
      removeIndex(part.product_list, idx);
    },
    selDateMin(date) {
      this.showcaseItem.start_date = date;
      // this.getData();
    },
    selDateMax(date) {
      this.showcaseItem.end_date = date;
      // this.getData();
    },
    // 삭제
    clickDelete(idx) {
      this.commentsArr.splice(idx, 1);
    },
    saveData() {
      let err = '';
      if(!this.showcaseItem.title) {
        err = '기획전 제목을 입력해주세요.';
      }

      if(err) {
        this.toast(err);
        return;
      }

      let value = this.cloneItem(this.showcaseItem);
      if(!value.start_date){
        value.start_date = '1111-01-01';
      }
      if(!value.end_date){
        value.end_date = '9999-01-01';
      }
      if(this.$route.query.id){
        this.$axios.patch(this.getUrl('exhibition_partner_product/')+this.$route.query.id, value).then(res=>{
          if(res.status===200){
            this.toast('저장되었습니다.');
            this.$router.replace(this.getPath('exhibition_partner_product'));
          }
        })
      }
      else{
        this.$axios.post(this.getUrl('exhibition_partner_product'), value).then(res=>{
          if(res.status===200){
            this.saveServiceGuide('partner_product_exhibition');
            this.toast('저장되었습니다.');
            this.$router.replace(this.getPath('exhibition_partner_product'));
          }
        })
      }
    },
    // 뒤로가기 (등록 취소)
    clickBack() {
      this.$router.back();
    },
    getData(){
      if(this.$route.query.id){
        this.$axios.get(this.getUrl('exhibition_partner_product/'+this.$route.query.id)).then(res=>{
          if(res.status===200){
            this.showcaseItem = res.data;
          }
        })
      }
    },
    rearrangeIndex() {
      let partners_id = [];
      for(let i=0; i<this.showcaseItem.partner_list.length; i++) {
        this.showcaseItem.partner_list[i]['index'] = i + 1;
        partners_id.push(this.showcaseItem.partner_list[i].id);

      }
      this.showcaseItem.partners = partners_id;
    }
  }
};
</script>

<style lang="stylus" type="stylus" scoped>
////@import '~assets/css/reset';
@import '~assets/css/lp_variable';
//@import '~assets/css/lp_main';

.tr-whole-border th
  padding 12px 6px

.many-field-tr td
  padding 6px

.user-reg-basic-group-1 {
  width: 50%;
}

.user-reg-basic-group-2 {
  width: 50%;
  margin-top: 137px;
}

.user-reg-content-service {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

.user-reg-service-group {
  width: 50%;
  padding-left: 20px;
  margin-bottom: 12px;
}

.user-reg-history-memo {
  width: 380px;
  height: 240px;
  margin: 0 10px;
  font-size: 0.9rem;
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #ddd;
  border-radius: 3px;
  padding: 12px;
  overflow-y: auto;
}

.history-memo-item {
  width: 100%;
  margin-bottom: 12px;
}

.user-reg-history-btn {
  background-color: $primary;
  color: #fff;
  display: inline-block;
  padding: 8px 12px;
  margin-left: 8px;
  border-radius: 3px;
  cursor: pointer;
}

.prod-search-btn {
  font-size: 0.8rem;
  background: #e6e6e6;
  padding: 6px 12px;
  border-radius: 3px;
  display: inline-block;
  cursor: pointer;
}

.prod-tag
  background-color $point
  display inline-block
  padding 4px 10px
  color #fff
  border-radius 3px
  margin 2px

.prod-detail-content
  padding 20px
  font-size .95rem
  color #222
  border-radius 3px
  border none
  background-color #f2f7f8
  display block
  width 100%
  max-width 900px
  height 120px

.comment-sub-title
  background #ddd
  color #333
  padding 8px 16px
  font-size .95rem
  border-radius 3px
  display flex
  justify-content space-between
</style>
